import { Frame } from '../atoms/Frame';
import { useT } from '../../../i18n/useT';
import { P, S, T } from '../../../styles/tokens';
import { usePlatformBack } from '../../../hooks/usePlatformBack';
import type { Checkpoint, CheckpointAttempt, SlotFlowRun } from '../../../api/flow-types';

interface TemplateProps {
  checkpoint: Checkpoint;
  attempt?: CheckpointAttempt;
  flowRun: SlotFlowRun;
  checkpoints: Checkpoint[];
  onCta: () => void;
}

export function AwaitingVerdict({ attempt }: TemplateProps) {
  const checkingText = useT('flow.checking');
  usePlatformBack();

  return (
    <Frame>
      <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 12,
          padding: '0 24px',
        }}
      >
        {/* Screenshot preview — rendered as dark card placeholder or real image */}
        {attempt?.artefact_path ? (
          <img
            src={attempt.artefact_path}
            alt="Загруженное фото"
            style={{
              width: 220,
              height: 280,
              borderRadius: 16,
              objectFit: 'cover',
              boxShadow: '0 12px 30px rgba(20,12,8,0.18)',
              marginBottom: 8,
            }}
          />
        ) : (
          /* Dark placeholder card when artefact not yet available */
          <div
            style={{
              width: 220,
              height: 280,
              borderRadius: 16,
              overflow: 'hidden',
              background: '#0E0A06',
              position: 'relative',
              boxShadow: '0 12px 30px rgba(20,12,8,0.18)',
              marginBottom: 8,
            }}
          >
            {/* Subtle hatched overlay */}
            <div
              style={{
                position: 'absolute',
                inset: 0,
                background: 'repeating-linear-gradient(45deg, #1a1410 0 10px, #2a2418 10px 20px)',
                opacity: 0.4,
              }}
            />
            <div
              style={{
                position: 'absolute',
                inset: 16,
                background: 'rgba(255,255,255,0.06)',
                borderRadius: 8,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'rgba(255,255,255,0.55)',
                fontSize: 11,
                fontFamily: T.fontMono,
              }}
            >
              SCREENSHOT
            </div>
          </div>
        )}

        {/* Terracotta spinner ring — matches prototype TF_Checking spinner */}
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: 28,
            border: `4px solid rgba(226,114,91,0.18)`,
            borderTopColor: P.terracotta,
            animation: 'spin 1s linear infinite',
            marginTop: 8,
          }}
        />

        {/* Checking copy */}
        <div style={{ font: T.headline, color: S.label, marginTop: 4 }}>
          {checkingText}
        </div>
        <div
          style={{
            font: T.footnote,
            color: S.secondaryLabel,
            textAlign: 'center',
            maxWidth: 240,
            lineHeight: 1.5,
          }}
        >
          ИИ читает скриншот. Обычно ~2 секунды.
        </div>
      </div>
    </Frame>
  );
}
